module.exports = __webpack_public_path__ + "img/DP358&DP458.4936548c.png";